import { Box, Button, Container, Typography } from "@material-ui/core";
import React, { useContext, useEffect } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import useBackButtonRedirect from "../hooks/useBackButton";
import SectionHeader from "../components/SectionHeader";
import { ThemeContext } from "../context/ThemeContext";

export default function ErrorPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { getPurchaseList } = useContext(ThemeContext);
  const [purchaseList, setPurchaseList] = getPurchaseList;

  useBackButtonRedirect();
  useEffect(() => {
    document.title = "エラー | じぶん専用IT相談室";
  }, []);
  var errorCode: any = searchParams.get("code")
    ? searchParams.get("code")
    : "400";
  var errorData = {
    "401": {
      title: "指定されたページを<br/>表示できません",
      message: "リクエスト先のページは存在しません",
    },
    "400": {
      title: "指定されたページを<br/>表示できません",
      message: "リクエスト先のページは存在しません",
    },
    "404": {
      title: "指定されたページを<br/>表示できません",
      message: "リクエスト先のページは存在しません",
    },
    "500": {
      title: "サーバーエラー",
      message: "システムエラーが発生しました。",
    },
    RESERVATION_TIMEOUT: {
      title: "予約日時の変更期限が過ぎております。",
      message:
        "ご不明な点がございましたら、下記のお問い合わせフォームより、お気軽に運営事務局までお問い合わせください",
    },
    signup: {
      title: "会員登録エラー",
      message:
        "本登録が完了できませんでした。お手数ですが、最初から会員登録をお願いいたします。\n\n次のいずれかが原因でエラーが発生しています。\n ・リンクに問題がある\n ・会員登録の有効期限切れ",
    },
    rating: {
      title: "指定されたページを<br/>表示できません",
      message:
        "次のいずれかが原因でエラーが発生しています。\n ・リンクに問題がある\n ・既に評価いただいた場合",
    },
    getCoupon: {
      title: "クーポンの獲得に失敗しました",
      message:
        "次のいずれかが原因でエラーが発生しています\n・リンクに問題がある\n・既にクーポンを取得いただいている\n・有効期限が切れている",
    },
    emailchange: {
      title: "指定されたページを<br/>表示できません",
      message:
        "次のいずれかが原因でエラーが発生しています。\n ・リンクに問題がある\n ・メールアドレス変更の有効期限切れ",
    },
  };
  if (errorCode == "RESERVATION_TIMEOUT") {
    setPurchaseList(undefined);
  }
  if (errorData[errorCode] == undefined) {
    errorCode = "404";
  }
  const replaceNewlinesWithParas = (text) => {
    const lines = text.split("\n");
    return lines.map((line, index) => (
      <Typography key={index} className="text-center mobile-text-left">
        {line}
      </Typography>
    ));
  };
  const navigate = useNavigate();
  return (
    <Box component={"section"} className="section bg-dots">
      <Container className="container">
        <SectionHeader
          currentPage={errorData[errorCode]["title"]}
          preHeading={"Error"}
        />
        {replaceNewlinesWithParas(errorData[errorCode]["message"])}
      </Container>
      <Box component={"section"} className="section text-center">
        <button className="classification-btn" onClick={() => navigate("/")}>
          ホームへ
        </button>
      </Box>
    </Box>
  );
}
